import { generateTestId } from "@client-shared";

export const setCustomersTableTestId = (identifier: string): string =>
  generateTestId("CustomersTable", identifier);

// Table Headers
export const setCustomersTableHeaderTestId = (column: string): string =>
  generateTestId("CustomersTable", `header-${column}`);

// Table Rows
export const setCustomersTableRowTestId = (id: string | number): string =>
  generateTestId("CustomersTable", `row-${id}`);

// Tier Badges
export const setCustomersTableTierBadgeTestId = (tier: string): string =>
  generateTestId("CustomersTable", `tier-${tier.toLowerCase()}`);
